import { useTranslation } from 'react-i18next';

import { Button, Label } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { UPLOAD_PICKER_TYPES } from '@/constants';
import { AssetScope } from '@/enums';
import { useFileUpload } from '@/hooks';
import { DroppedAssetUpload } from '@/types';

export const DroppedAssetPopup = ({
  files,
  onClose,
  pickerTypes = UPLOAD_PICKER_TYPES.MEDIA,
  eventId,
  organizationId,
  isPublic,
  assetTag,
  handleCreatedAsset,
  setShouldRefetch,
  maxAssets,
  isMaxAssetsSizeLimited
}: DroppedAssetUpload) => {
  const [t] = useTranslation('common');

  const { uploadFiles, isUploading } = useFileUpload({
    eventId,
    organizationId,
    isPublic,
    pickerTypes,
    assetScope: isPublic ? AssetScope.PUBLIC : AssetScope.PRIVATE,
    assetTag,
    maxFiles: isMaxAssetsSizeLimited ? (maxAssets ?? undefined) : undefined,
    onCreatedAsset: handleCreatedAsset,
    onRefetchNeeded: () => setShouldRefetch?.(true)
  });

  const handleUpload = async () => {
    await uploadFiles(files);
    onClose();
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
      <div className='rounded-lg bg-white p-6 shadow-lg'>
        <Label
          className='mb-4 text-lg font-semibold'
          text={t('dropFileUpload', {
            count: files.length,
            fileWord: files.length > 1 ? t('files') : t('file')
          })}
        />

        <div className='flex w-full justify-center space-x-4'>
          <Button variant={ButtonVariant.SECONDARY} handleOnClick={onClose}>
            {t('cancel')}
          </Button>

          <Button
            variant={ButtonVariant.PRIMARY}
            handleOnClick={handleUpload}
            disabled={isUploading}>
            {isUploading ? t('uploading') : t('upload')}
          </Button>
        </div>
      </div>
    </div>
  );
};
